import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from 'react';
import { logger } from '@/lib/telemetry/logger';
import { FundingProviderLoading } from '../shared/funding-provider-loading';

// Provider authentication needs its own origin. The allowlist prevents a same-origin
// document from using scripts to remove the sandbox from Morfi's DOM.
const providerSandbox: string = ['allow-scripts', 'allow-same-origin', 'allow-forms', 'allow-popups', 'allow-popups-to-escape-sandbox', 'allow-top-navigation-by-user-activation'].join(' ');
export function SellProviderFrame(t0) {
  const $ = _c(12);
  const {
    url
  } = t0;
  const [loadedUrl, setLoadedUrl] = useState(null);
  const source = new URL(url);
  if (source.origin !== "https://platform.moonpay.com" || source.pathname !== "/v2/sell" || source.username || source.password) {
    throw new Error("offramp_invalid_checkout_origin");
  }
  let t1;
  if ($[0] !== loadedUrl || $[1] !== url) {
    t1 = loadedUrl !== url ? <div className="absolute inset-0"><FundingProviderLoading /></div> : null;
    $[0] = loadedUrl;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== url) {
    t2 = () => setLoadedUrl(url);
    $[3] = url;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = loadedUrl === url ? "h-145 w-full border-0" : "h-145 w-full border-0 opacity-0";
  let t4;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== url) {
    t4 = <iframe title="MoonPay" src={url} allow="camera https://platform.moonpay.com; payment https://platform.moonpay.com" sandbox={providerSandbox} onLoad={t2} onError={_temp} className={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = url;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="relative h-145 w-full">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp() {
  return logger.warn("offramp.hosted_failed", {
    surface: "web",
    phase: "load"
  });
}